/**
 * ScaleLegend Component
 * Displays a horizontal legend row of colored dots with labels for the 5-point scale.
 */

import { SCALE_COLORS } from './scaleColors';
import styles from './StackedBarChart.module.css';

interface ScaleLegendProps {
  labels?: string[];
  /** Short explanation shown at the end of the row, e.g. what the % means */
  note?: string;
}

const DEFAULT_LABELS = [
  'Strongly disagree',
  'Disagree',
  'Neutral',
  'Agree',
  'Strongly agree',
];

export function ScaleLegend({ labels = DEFAULT_LABELS, note }: ScaleLegendProps) {
  return (
    <div className={styles.legend}>
      {labels.map((label, index) => (
        <div key={label} className={styles.legendItem}>
          <div
            className={styles.legendDot}
            style={{ backgroundColor: SCALE_COLORS[index % SCALE_COLORS.length] }}
          />
          {label}
        </div>
      ))}
      {note && <span className={styles.legendNote}>{note}</span>}
    </div>
  );
}

export default ScaleLegend;
